"use strict";

var _regeneratorRuntime = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _FDSMultibox = _interopRequireDefault(require("./FDS-Multibox.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Mailbox =
/*#__PURE__*/
function () {
  function Mailbox(config) {
    _classCallCheck(this, Mailbox);

    this.config = config;
    this.web3 = this.config.web3;
    this.gasPrice = (0, _web3Utils.toWei)(config.gasPrice.toString(), 'gwei');
  }
  /**
   * encode feed locatio hash
   * @param {any} senderAddress address
   * @param {any} recipientNamehash recepient hash 
   * @returns {any} encoded sender and recipient hash
   */


  _createClass(Mailbox, [{
    key: "encodeFeedLocationHash",
    value: function encodeFeedLocationHash(senderAddress, recipientNamehash) {
      return senderAddress + recipientNamehash.substr(42, 66);
    }
    /**
     * subdomain name hash to feed location hash
     * @param {any} recipientNamehash hash of recipient name
     * @returns {any} substring of recepient name hash that is feed location hash
     */

  }, {
    key: "subdomainNameHashToFeedLocationHash",
    value: function subdomainNameHashToFeedLocationHash(recipientNamehash) {
      return recipientNamehash.substr(42, 66);
    }
    /**
     * Decode feed location
     * @param {any} feedLocationHash hash of feed location
     * @returns {any} object with address and topic
     */

  }, {
    key: "decodeFeedLocationHash",
    value: function decodeFeedLocationHash(feedLocationHash) {
      return {
        address: feedLocationHash.substring(0, 42),
        topic: feedLocationHash.substr(42, 66)
      };
    } // async newInboxFeed(account, recipientSubdomain, multiboxAddress, feedLocationHash, applicationDomain = 'shared') {
    //     let multibox = await new Multibox(account, this.config).at(multiboxAddress);
    //     return multibox.set(`/shared/mail/$(applicationDomain)/$(senderAccount.subdomain)`, feedLocationHash);
    // }
    // async getInboxFeed(account, subdomain, multiboxAddress, applicationDomain = 'shared'){
    //     let multibox = await new Multibox(account, this.config).at(multiboxAddress);
    //     return multibox.get(`/shared/mail/$(applicationDomain)/$(subdomain)`);
    // }

  }, {
    key: "newInboxFeed",
    value: function newInboxFeed(senderAccount, subdomain, senderSubdomainNamehash, multiboxAddress, feedLocationHash, multiboxPath) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var multibox;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _FDSMultibox.default(senderAccount, _this.config).at(multiboxAddress);

              case 2:
                multibox = _context.sent;
                return _context.abrupt("return", multibox.set(multiboxPath, senderSubdomainNamehash, feedLocationHash));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, {
    key: "getInboxFeed",
    value: function getInboxFeed(senderAccount, subdomain, multiboxAddress, path) {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var multibox;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new _FDSMultibox.default(senderAccount, _this2.config).at(multiboxAddress);

              case 2:
                multibox = _context2.sent;
                return _context2.abrupt("return", multibox.get(path));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "getInboxFeeds",
    value: function getInboxFeeds(account, multiboxAddress, path) {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var multibox;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new _FDSMultibox.default(account, _this3.config).at(multiboxAddress);

              case 2:
                multibox = _context3.sent;
                return _context3.abrupt("return", multibox.get(path));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }]);

  return Mailbox;
}();

var _default = Mailbox;
exports.default = _default;
module.exports = exports.default;